import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import axios from 'axios';
import { useEffect, useState } from 'react';

export default function Brands() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const [data, setData] = useState([]);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/brand");
                setData(response.data.brands)
            }
            catch (error) {
                console.error("Error Fetch Data : ", error);
            }
        }

        fetchData();
    }, [])
    return (
        <>
            <section className="landingPages">
                <div className="container h-full flex flex-col gap-[10px] justify-center">
                    <div className="text-[35px] font-bold text-white">{t("All Brands")} </div>
                    <div className="flex items-center gap-[3px] text-white">
                        <Link to={"/"}>{t("Home")}</Link>
                        <span>-</span>
                        <div>{t("All Brands")} </div>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container f-col flex flex-wrap gap-[20px]">
                    {data.map((el) => (
                        <Link to={`/brandsProducts/${el.brand_name}`} className="flex flex-col items-center text-center">
                            <div className='back-category flex justify-center items-center p-[20px] w-[150px] h-[150px] shadow-lg rounded-md overflow-hidden'>
                                <img src={`https://laravel-api.aj-mart.com/storage/app/public/${el.brand_img}`} alt={el.brand_name} className="w-full h-auto max-w-[200px] object-contain" />
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </>
    );
}